export default __webpack_public_path__ + "images/150f6dcfd081184404e3b7c62bd77838.svg";